import { IconButton as MUIIconButton, IconButtonProps } from '@mui/material';

export const IconButton = (props: IconButtonProps) => {
  return <MUIIconButton {...props} />;
};
